import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import {
  FaChevronLeft,
  FaChevronRight,
  FaChevronDown,
  FaChevronUp,
} from 'react-icons/fa';
import { device } from 'utils/device'

const Pagination = ({ items, onPageChange, toolbar, id, onClose }) => {
  const [pageSize, setPageSize] = useState(toolbar ? 1 : 10);
  const [page, setPage] = useState();
  const [pages, setPages] = useState();

  const handleChange = (e) => {
    setPageSize(e.target.value);
  };

  const setNewItems = () => {
    if (page && pageSize) {
      const newItems = items.slice((page - 1) * pageSize, page * pageSize);
      onPageChange(newItems);
    }
  };

  useEffect(() => {
    if (id && items) {
      const ix = items.findIndex((item) => {
        return item.id == id;
      });

      setPage(ix + 1);
    }
  }, []);

  useEffect(() => {
    if (items) {
      setPages(Math.ceil(items.length / pageSize));
      if (!id) {
        page === 1 ? setNewItems() : setPage(1);
      }
    }
  }, [pageSize]);

  useEffect(() => {
    if (page) {
      setNewItems();
    }
  }, [page]);

  const renderPagination = () => {
    const theOffset = page * pageSize < items.length ? page * pageSize : items.length;

    return (
      items.length ? (
        <StyledPagination>
          <div>Rows per Page: </div>
          <div>
            <Select onChange={handleChange} value={pageSize}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
          </div>
          <PageDetail>
            {pages &&
              `${page * pageSize - pageSize || 1}-${theOffset} of ${
                items.length
              }`}
          </PageDetail>
          <div>
            <PageButton
              variant="link"
              onClick={() => setPage(page - 1)}
              disabled={page <= 1}
            >
              <FaChevronLeft /> Back
            </PageButton>
            {pages &&
              [...Array(pages)].map((p, i) => (
                <PageButton key={i} variant="link" onClick={() => setPage(i + 1)}>
                  {page === i + 1 ? (
                    <strong>{i + 1}</strong>
                  ) : (
                    <span>{i + 1}</span>
                  )}
                </PageButton>
              ))}
            <PageButton
              variant="link"
              onClick={() => setPage(page + 1)}
              disabled={page === pages || pages === 1}
            >
              Next <FaChevronRight />
            </PageButton>
          </div>
        </StyledPagination>) : null
    );
  };

  const renderToolBar = () => {
    return (
      <StyledToolbar>
        <PageDetail>{pages && `${page} of ${items.length}`}</PageDetail>
        <PageButton
          variant="link"
          onClick={() => setPage(page - 1)}
          disabled={page <= 1}
        >
          <FaChevronUp /> PREVIOUS
        </PageButton>
        <PageButton
          variant="link"
          onClick={() => setPage(page + 1)}
          disabled={page === pages || pages === 1}
        >
          <FaChevronDown /> NEXT
        </PageButton>
        <PageButton
          variant="link"
          onClick={() => onClose()}
        >
          <FaChevronRight /> BACK TO LIST
        </PageButton>
      </StyledToolbar>
    );
  };

  return toolbar ? renderToolBar() : renderPagination();
};

const PageDetail = styled.div`
  margin: 0 2rem;

  @media ${device.mobileL} {
    display: none;
  }
`;

const PageButton = styled(Button)`
  color: #305daa;
  font-size: 0.9rem;
  padding: 0.3rem;
`;

const StyledToolbar = styled.div`
  display: flex;
  align-items: right;
  color: #808080;
  font-size: 0.9rem;
  white-space: nowrap;
  align-items: center;
`;

const StyledPagination = styled.div`
  display: flex;
  align-items: center;
  color: #808080;
  font-size: 0.9rem;
  white-space: nowrap;
`;

const Select = styled.select`
  border: 0;
  background-color: white;
  color: #808080;
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23305DAA%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat, repeat;
  /* arrow icon position (1em from the right, 50% vertical) , then gradient position*/
  background-position: right 0.7em top 50%, 0 0;
  /* icon size, then gradient */
  background-size: 1rem auto, 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  margin: 0 0.5rem;
  width: 3rem;
  &::-ms-expand {
    display: none;
  }
`;

export default Pagination;
